module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "main-wrapper__footer row is-desctop"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-foot col"
  }, [_c('div', {
    staticClass: "item_in-col"
  }, [_c('ui_sub_title_text', [_vm._v("О сервисе:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item_in-col"
  }, [_c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_vm._v("Как это работает?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item_in-col"
  }, [_c('router-link', {
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v("Политика конфиденциальности")])], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-foot col"
  }, [_c('div', {
    staticClass: "item_in-col"
  }, [_c('ui_sub_title_text', [_vm._v("Клиентам:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item_in-col"
  }, [_c('router-link', {
    attrs: {
      "to": "/safety"
    }
  }, [_vm._v("Безопасная сделка")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item_in-col"
  }, [_c('router-link', {
    attrs: {
      "to": "/search"
    }
  }, [_vm._v("Найти адвоката")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item_in-col"
  }, [_c('router-link', {
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v("Политика конфиденциальности")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item_in-col"
  }, [_c('button', {
    staticStyle: {
      "border": "none !important",
      "outline": "none !important"
    },
    on: {
      "click": _vm.toApplying
    }
  }, [_vm._v("Срочная помощь адвоката")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-foot col"
  }, [_c('div', {
    staticClass: "item_in-col"
  }, [_c('ui_sub_title_text', [_vm._v("Адвокату:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item_in-col"
  }, [_c('router-link', {
    attrs: {
      "to": "/insurance"
    }
  }, [_vm._v("Страхование")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "is-mobile"
  }, [_c('div', {
    staticClass: "red-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "list-button"
  }, [_c('div', {
    staticClass: "button-set-footer",
    class: _vm.setFooter === 'service' ? 'button-set-footer__active' : '',
    on: {
      "click": function($event) {
        return _vm.setList('service')
      }
    }
  }, [_vm._v("\n        О сервисе\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "button-set-footer",
    class: _vm.setFooter === 'advocate' ? 'button-set-footer__active' : '',
    on: {
      "click": function($event) {
        return _vm.setList('advocate')
      }
    }
  }, [_vm._v("\n        Адвокату\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "button-set-footer",
    class: _vm.setFooter === 'client' ? 'button-set-footer__active' : '',
    on: {
      "click": function($event) {
        return _vm.setList('client')
      }
    }
  }, [_vm._v("\n        Клиенту\n      ")])]), _vm._v(" "), (_vm.itemsList.length > 0) ? _c('div', {
    staticClass: "list-open animate__animated animate__fadeInLeft"
  }, _vm._l((_vm.itemsList), function(item) {
    return _c('div', {
      key: 'list' + item.name,
      staticClass: "item"
    }, [(item.href !== '/static/doc/offerta.pdf') ? _c('router-link', {
      attrs: {
        "to": item.href
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('a', {
      attrs: {
        "target": "_blank",
        "href": item.href
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 0) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offset-md-1 col-foot col"
  }, [_c('div', {
    staticClass: "item_in-col logo-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/logo_full.svg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item_in-col"
  }, [_c('img', {
    staticClass: "img-soc",
    attrs: {
      "src": "/static/img/icon_phone.svg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+74956425292"
    }
  }, [_vm._v("+7 (495) 64 25 292")])]), _vm._v(" "), _c('div', {
    staticClass: "item_in-col"
  }, [_c('img', {
    staticClass: "img-soc",
    attrs: {
      "src": "/static/img/icon_mail_dark.svg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto: info@mobileadvokat.ru"
    }
  }, [_vm._v("info@mobileadvokat.ru")])]), _vm._v(" "), _c('div', {
    staticClass: "item_in-col wrapper-icons-social"
  }, [_c('a', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "href": "https://wa.me/79910830833"
    }
  }, [_c('img', {
    staticClass: "margin-right-1",
    staticStyle: {
      "width": "36px"
    },
    attrs: {
      "src": "/static/img/icon_whatsapp_black.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://vk.com/mob_advokat"
    }
  }, [_c('img', {
    staticClass: "margin-right-1",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": "/static/img/vk-02-01.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCOyKsErmFTcl23B2ckPA0MQ"
    }
  }, [_c('img', {
    staticClass: "margin-right-1",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": "/static/img/you-02-01.svg"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item_in-col"
  }, [_c('a', {
    attrs: {
      "href": "/static/doc/offerta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Условия использования")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37958428","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/footer.vue
// module id = 348
// module chunks = 2